import Vue from 'vue'
export default {
  data() {
    return {}
  },
  methods: {
    ISODateString(date) {
      return date.toISOString().split('T')[0]
    },
    getDiffYearDate(diffYear) {
      const year = new Date().getFullYear() - diffYear
      const month = new Date().getMonth()
      const day = new Date().getDate()
      return new Date(year, month, day)
    }
  }
}
